var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"100000"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"100"}},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }